import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Router } from '@angular/router';
const screenfull = require('screenfull');
import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { DataService } from './../../Service/data.service';
import { ConfirmDialogService } from '../../adminUsers/confirm-dialog/confirm-dialog.service';
import { environment } from 'src/environments/environment.prod';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    constructor(public menu: MenuService, public userblockService: UserblockService,
                private ngxLoader: NgxUiLoaderService,
                public settings: SettingsService, public injector: Injector, private route: Router, private DataServiceObj: DataService, private confirmDialogService: ConfirmDialogService) {

        // show only a few items on demo
        this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
        this.DataServiceObj.firstName.subscribe(updatedTitle => {
            console.log(updatedTitle);
            this.LoggedInUserFirstName = updatedTitle;
        });
    }
    response: any;
    showData: boolean;
    allUserData: any;
    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    router: Router;
    term;

    isNavSearchVisible: boolean;
    @ViewChild('fsbutton', { static: true }) fsbutton;  // the fullscreen button

    LoggedInUserFirstName;
    display = 'none';
    debounceTimer: any;
    recentSearches: string[] = [];
    searchFocused = false;
    private readonly searchHistoryKey = 'headerSubscriberSearchHistory';

    ngOnInit() {
        const userToken = this.DataServiceObj.getUserToken();
        this.isNavSearchVisible = false;
        this.loadRecentSearchHistory();

        const ua = window.navigator.userAgent;
        if (ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }

        // Switch fullscreen icon indicator
        // const el = this.fsbutton.nativeElement.firstElementChild;
        // screenfull.on('change', () => {
        //     if (el)
        //         el.className = screenfull.isFullscreen ? 'fa fa-compress' : 'fa fa-expand';
        // });

        this.router = this.injector.get(Router);

        // Autoclose navbar on mobile when route change
        this.router.events.subscribe((val) => {
            // scroll view to top
            window.scrollTo(0, 0);
            // close collapse menu
            this.navCollapsed = true;
        });
        this.getAdminUserDetails(userToken);
        this.setData();
    }
    setData() {
        const UsersData = JSON.parse(sessionStorage.getItem('userLogin'));
        this.LoggedInUserFirstName = UsersData.Data.firstname;
    }
    openModal() {
        const userToken = this.DataServiceObj.getUserToken();
        this.getAdminUserDetails(userToken);
        this.display = 'block';
    }
    onCloseHandled() {
        this.display = 'none';
    }

    onSearchFocus() {
        this.searchFocused = true;
    }

    onSearchBlur() {
        setTimeout(() => {
            this.searchFocused = false;
        }, 150);
    }

    onSearchChange(value: string) {
        this.term = value;
        this.searchFocused = true;
    }

    clearSearch() {
        this.term = '';
        this.searchFocused = true;
    }

    selectRecentSearch(searchTerm: string) {
        this.term = searchTerm;
        this.searchFocused = true;
    }

    clearRecentSearches() {
        this.recentSearches = [];
        this.persistRecentSearchHistory();
    }

    rememberSearch(searchTerm: string) {
        const normalizedSearch = (searchTerm || '').trim();
        if (!normalizedSearch) {
            return;
        }

        this.recentSearches = [normalizedSearch, ...this.recentSearches.filter(item => item.toLowerCase() !== normalizedSearch.toLowerCase())].slice(0, 6);
        this.persistRecentSearchHistory();
    }

    getFilteredSubscribers() {
        const subscribers = Array.isArray(this.allUserData) ? this.allUserData : [];
        const normalizedSearch = (this.term || '').trim().toLowerCase();

        if (!normalizedSearch) {
            return subscribers;
        }

        return subscribers.filter((user: any) => {
            const companyName = (user && user.companyName ? String(user.companyName) : '').toLowerCase();
            const dvId = user && user.dvID ? String(user.dvID).toLowerCase() : '';

            return companyName.includes(normalizedSearch) || dvId.includes(normalizedSearch);
        });
    }

    getVisibleSubscriberCount() {
        return this.getFilteredSubscribers().length;
    }

    get searchSuggestions() {
        const subscribers = Array.isArray(this.allUserData) ? this.allUserData : [];
        const normalizedSearch = (this.term || '').trim().toLowerCase();

        if (normalizedSearch.length < 2) {
            return subscribers.slice(0, 5);
        }

        return subscribers
            .filter((user: any) => {
                const companyName = (user && user.companyName ? String(user.companyName) : '').toLowerCase();
                const dvId = user && user.dvID ? String(user.dvID).toLowerCase() : '';

                return companyName.includes(normalizedSearch) || dvId.includes(normalizedSearch);
            })
            .slice(0, 5);
    }

    get recentSearchMatches() {
        const normalizedSearch = (this.term || '').trim().toLowerCase();

        if (!normalizedSearch) {
            return this.recentSearches.slice(0, 6);
        }

        return this.recentSearches.filter(item => item.toLowerCase().includes(normalizedSearch)).slice(0, 6);
    }

    showSearchAssistPanel() {
        return this.searchFocused || !!(this.term && this.term.trim()) || this.recentSearches.length > 0;
    }

    private loadRecentSearchHistory() {
        if (typeof window === 'undefined' || !window.localStorage) {
            this.recentSearches = [];
            return;
        }

        try {
            const storedHistory = window.localStorage.getItem(this.searchHistoryKey);
            const parsedHistory = storedHistory ? JSON.parse(storedHistory) : [];
            this.recentSearches = Array.isArray(parsedHistory) ? parsedHistory.filter((item: any) => typeof item === 'string' && item.trim().length > 0).slice(0, 6) : [];
        } catch (error) {
            this.recentSearches = [];
        }
    }

    private persistRecentSearchHistory() {
        if (typeof window === 'undefined' || !window.localStorage) {
            return;
        }

        window.localStorage.setItem(this.searchHistoryKey, JSON.stringify(this.recentSearches));
    }

    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.toggleLayoutSetting('offsidebarOpen');
    }

    toggleCollapsedSideabar() {
        this.settings.toggleLayoutSetting('isCollapsed');
    }

    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }

    toggleFullScreen(event) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
    }

    navigateTo2StepAuth() {
        this.route.navigate(['/twoFaAuth']);
        // window.scrollTo(0, 0);
    }

    adminLogout() {
        const obj = this;
        this.confirmDialogService.confirmThis('Are you sure you want to logout?', function() {
            sessionStorage.clear();
            obj.DataServiceObj.RemoveUserToken();
            obj.route.navigate(['/login']);
        }, function() {
        });

    }

    getAdminUserDetails(userToken) {
        const payLoad = {
            page: 1,
            limit: 10000,
            search: '',
            sortOrder: 'ASC',
            isDeleted: 0
        };
        this.DataServiceObj.getAdminUserDetails('admin/user/getAllSubscribers', userToken, payLoad).subscribe(res => {
            this.response = res;
            const payload = this.response && (this.response.Data || this.response.data || {});
            const subscribers = payload && payload.subscribers ? payload.subscribers : [];
            this.allUserData = Array.isArray(subscribers) ? subscribers.filter((v: any) => v.isDeleted == 0) : [];
            if (payload) {
            } else {
                this.showData = false;
            }
        },
            err => {

            });
    }
    subscriberSwitch(user: any) {
this.ngxLoader.start();
this.rememberSearch(this.term || (user && user.companyName ? user.companyName : ''));
const data = {
            id: user.id,
            role: 'admin',
            subscriberType: user.subscriberType
        };
const subscriberLogin = { Data: data, tableName: 'txnUsers', companyName: user.companyName };
sessionStorage.setItem('subscriberLogin', JSON.stringify(subscriberLogin));
this.onCloseHandled();
console.log(window.location.href, environment.dataUrl + '#/home');
const url = 'http://localhost:4200/';
        // if(window.location.href==url+'#/home')

if (window.location.href == environment.dataUrl + '#/home')
        {
            console.log('true');
            window.location.reload();

        }
        else{
            this.router.navigateByUrl('/home');
            this.debounceTimer = setTimeout(() => {
        window.location.reload();
        this.ngxLoader.stop()
;
    }, 1000);

        }
console.log('going');
        // window.location.reload();
        // this.reload('/home')
        // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        //     this.router.navigate(['/home']);
        // });
        // this.router.navigateByUrl('/home', { skipLocationChange: true }).then(() =>
            // this.router.navigate(['/susbcriber-header'])
        // this.router.navigate(['/home'])
        // , {queryParams: {"login": 'Subscriber'}})
        // this.onCloseHandled();
    // );

    }
    async reload(url: string): Promise<boolean> {
        await this.router.navigateByUrl('.', { skipLocationChange: true });
        return this.router.navigateByUrl(url);
      }

    editProfile() {
        this.router.navigate(['/edit_profile']);
    }

}
